import Link from 'next/link'

export function TextLink({ href, children }: { href: string; children: React.ReactNode }) {
	return (
		<Link
			href={href}
			className="inline-flex items-center gap-2 text-[12px] font-semibold tracking-wider text-[var(--brand-primary)]"
		>
			{children}
		</Link>
	)
}
